"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loadUserActivities = loadUserActivities;
exports.replayUserActivity = replayUserActivity;
exports.createUserActivity = createUserActivity;
exports.editUserActivity = editUserActivity;
exports.deleteUserActivity = deleteUserActivity;
exports.watchLoadUserActivities = watchLoadUserActivities;
exports.watchReplayUserActivity = watchReplayUserActivity;
exports.watchCreateUserActivity = watchCreateUserActivity;
exports.watchEditUserActivity = watchEditUserActivity;
exports.watchDeleteUserActivity = watchDeleteUserActivity;
exports["default"] = exports.userActivitiesSagas = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _utils = require("../../../utils");

var _actions = _interopRequireDefault(require("./actions"));

var _marked = _regenerator["default"].mark(loadUserActivities),
    _marked2 = _regenerator["default"].mark(replayUserActivity),
    _marked3 = _regenerator["default"].mark(createUserActivity),
    _marked4 = _regenerator["default"].mark(editUserActivity),
    _marked5 = _regenerator["default"].mark(deleteUserActivity),
    _marked6 = _regenerator["default"].mark(watchLoadUserActivities),
    _marked7 = _regenerator["default"].mark(watchReplayUserActivity),
    _marked8 = _regenerator["default"].mark(watchCreateUserActivity),
    _marked9 = _regenerator["default"].mark(watchEditUserActivity),
    _marked10 = _regenerator["default"].mark(watchDeleteUserActivity);

function loadUserActivities(api, action) {
  var _action$payload, userId, clientId, _action$payload$skip, skip, _action$payload$limit, limit, startAt, endAt, search, data;

  return _regenerator["default"].wrap(function loadUserActivities$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _action$payload = action.payload, userId = _action$payload.userId, clientId = _action$payload.clientId, _action$payload$skip = _action$payload.skip, skip = _action$payload$skip === void 0 ? 0 : _action$payload$skip, _action$payload$limit = _action$payload.limit, limit = _action$payload$limit === void 0 ? 20 : _action$payload$limit, startAt = _action$payload.startAt, endAt = _action$payload.endAt, search = _action$payload.search;
          _context.prev = 1;
          _context.next = 4;
          return api.getActivities({
            userId: userId,
            clientId: clientId,
            skip: skip,
            limit: limit,
            startAt: startAt,
            endAt: endAt,
            search: search
          }).then(function (p) {
            return p.request;
          });

        case 4:
          data = _context.sent;
          _context.next = 7;
          return (0, _effects.put)(_actions["default"].loadUserActivitiesSuccess(data));

        case 7:
          _context.next = 13;
          break;

        case 9:
          _context.prev = 9;
          _context.t0 = _context["catch"](1);
          _context.next = 13;
          return (0, _effects.put)(_actions["default"].loadUserActivitiesError(_context.t0));

        case 13:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 9]]);
}

function replayUserActivity(api, action) {
  var activityId;
  return _regenerator["default"].wrap(function replayUserActivity$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          activityId = action.payload.activityId;
          _context2.prev = 1;
          _context2.next = 4;
          return api.replayActivity({
            activityId: activityId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context2.next = 6;
          return (0, _effects.put)(_actions["default"].replayUserActivitySuccess({
            activityId: activityId
          }));

        case 6:
          _context2.next = 12;
          break;

        case 8:
          _context2.prev = 8;
          _context2.t0 = _context2["catch"](1);
          _context2.next = 12;
          return (0, _effects.put)(_actions["default"].replayUserActivityError(_context2.t0));

        case 12:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[1, 8]]);
}

function createUserActivity(api, action) {
  var _action$payload2, activity, userId, clientId;

  return _regenerator["default"].wrap(function createUserActivity$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _action$payload2 = action.payload, activity = _action$payload2.activity, userId = _action$payload2.userId, clientId = _action$payload2.clientId;
          _context3.prev = 1;
          _context3.next = 4;
          return api.createActivity({
            activity: activity,
            userId: userId,
            clientId: clientId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context3.next = 6;
          return (0, _effects.put)(_actions["default"].createUserActivitySuccess());

        case 6:
          _context3.next = 12;
          break;

        case 8:
          _context3.prev = 8;
          _context3.t0 = _context3["catch"](1);
          _context3.next = 12;
          return (0, _effects.put)(_actions["default"].createUserActivityError(_context3.t0));

        case 12:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[1, 8]]);
}

function editUserActivity(api, action) {
  var _action$payload3, activity, userId;

  return _regenerator["default"].wrap(function editUserActivity$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _action$payload3 = action.payload, activity = _action$payload3.activity, userId = _action$payload3.userId;
          _context4.prev = 1;
          _context4.next = 4;
          return api.editActivity({
            activity: activity,
            userId: userId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context4.next = 6;
          return (0, _effects.put)(_actions["default"].editUserActivitySuccess({
            activityId: activity._id
          }));

        case 6:
          _context4.next = 12;
          break;

        case 8:
          _context4.prev = 8;
          _context4.t0 = _context4["catch"](1);
          _context4.next = 12;
          return (0, _effects.put)(_actions["default"].editUserActivityError(_context4.t0));

        case 12:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 8]]);
}

function deleteUserActivity(api, action) {
  var _action$payload4, activityId, userId;

  return _regenerator["default"].wrap(function deleteUserActivity$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _action$payload4 = action.payload, activityId = _action$payload4.activityId, userId = _action$payload4.userId;
          _context5.prev = 1;
          _context5.next = 4;
          return api.deleteActivity({
            activityId: activityId,
            userId: userId
          }).then(function (p) {
            return p.request;
          });

        case 4:
          _context5.next = 6;
          return (0, _effects.put)(_actions["default"].deleteUserActivitySuccess({
            activityId: activityId
          }));

        case 6:
          _context5.next = 12;
          break;

        case 8:
          _context5.prev = 8;
          _context5.t0 = _context5["catch"](1);
          _context5.next = 12;
          return (0, _effects.put)(_actions["default"].deleteUserActivityError(_context5.t0));

        case 12:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5, null, [[1, 8]]);
}

function watchLoadUserActivities(api) {
  return _regenerator["default"].wrap(function watchLoadUserActivities$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].loadUserActivities), loadUserActivities, api);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}

function watchReplayUserActivity(api) {
  return _regenerator["default"].wrap(function watchReplayUserActivity$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].replayUserActivity), replayUserActivity, api);

        case 2:
        case "end":
          return _context7.stop();
      }
    }
  }, _marked7);
}

function watchCreateUserActivity(api) {
  return _regenerator["default"].wrap(function watchCreateUserActivity$(_context8) {
    while (1) {
      switch (_context8.prev = _context8.next) {
        case 0:
          _context8.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].createUserActivity), createUserActivity, api);

        case 2:
        case "end":
          return _context8.stop();
      }
    }
  }, _marked8);
}

function watchEditUserActivity(api) {
  return _regenerator["default"].wrap(function watchEditUserActivity$(_context9) {
    while (1) {
      switch (_context9.prev = _context9.next) {
        case 0:
          _context9.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].editUserActivity), editUserActivity, api);

        case 2:
        case "end":
          return _context9.stop();
      }
    }
  }, _marked9);
}

function watchDeleteUserActivity(api) {
  return _regenerator["default"].wrap(function watchDeleteUserActivity$(_context10) {
    while (1) {
      switch (_context10.prev = _context10.next) {
        case 0:
          _context10.next = 2;
          return (0, _effects.takeLatest)((0, _utils.getType)(_actions["default"].deleteUserActivity), deleteUserActivity, api);

        case 2:
        case "end":
          return _context10.stop();
      }
    }
  }, _marked10);
}

var userActivitiesSagas = function userActivitiesSagas(api) {
  return [(0, _effects.fork)(watchLoadUserActivities, api), (0, _effects.fork)(watchReplayUserActivity, api), (0, _effects.fork)(watchCreateUserActivity, api), (0, _effects.fork)(watchEditUserActivity, api), (0, _effects.fork)(watchDeleteUserActivity, api)];
};

exports.userActivitiesSagas = userActivitiesSagas;
var _default = userActivitiesSagas;
exports["default"] = _default;
//# sourceMappingURL=sagas.js.map